var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modules-grid',{attrs:{"items":_vm.items,"total":_vm.total,"loading":_vm.loading},on:{"paginate":_vm.onPaginate,"navigateTo":_vm.navigateTo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }